// extracted by mini-css-extract-plugin
module.exports = {"icon":"Styles_icon__3iE4B","imageEditorPlaceholder":"Styles_imageEditorPlaceholder__1Xc5A","socialIcons":"Styles_socialIcons__f_Bbi","imageFile":"Styles_imageFile__1LehL"};